var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ImageBanner'),_c('b-container',[_c('b-row',[_c('b-col'),_c('b-col',{attrs:{"cols":"8"}},[_c('Debate')],1),_c('b-col')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }